import gql from 'graphql-tag';

const DAILY_SUMMARY_FRAGMENT = gql`
	fragment serviceRunsDailySummary on ServiceRun {
		id
		planned
		cashReconciliationStatus
		order
		restockType
		ignoreSitePermissions
		brief
		machineCount
		warehouse {
			id
			name
		}
		returnWarehouse {
			id
			name
		}
		route {
			id
			name
		}
		driver {
			id
			username
			firstname
			lastname
			destroyed
			userSitePermissions {
				id
				expiresAt
				sitePermission {
					id
					policy
				}
			}
		}
		vehicle {
			id
			name
			lastCoordinates
		}
		serviceDockets {
			id
			place {
				id
			}
		}
	}
`;

export default DAILY_SUMMARY_FRAGMENT;
